/* Keep the server-rendered reviews and rating links available immediately.
   Hydrate the full Okendo controls when the reader approaches the reviews. */
(() => {
  const widget = document.querySelector('[data-tg-review-widget]');
  if (!widget || widget.dataset.tgObserved) return;
  widget.dataset.tgObserved = 'true';
  let requested = false;
  let loading = false;
  let observer;

  const hydrate = async () => {
    requested = true;
    if (loading || !window.okeWidgetApi?.initWidget) return;
    loading = true;
    observer?.disconnect();
    widget.setAttribute('data-oke-widget', '');
    try {
      await window.okeWidgetApi.initWidget(widget);
      widget.dataset.tgHydrated = 'true';
    } catch (error) {
      loading = false;
      console.warn('TsukiGlass reviews could not initialize; the saved reviews remain visible.', error);
    }
  };

  document.addEventListener('oke-script-loaded', () => {
    if (requested) hydrate();
  }, { once: true });
  document.addEventListener('click', event => {
    if (event.target.closest('a[href="#ProductReviews"], [data-tg-review-widget]')) hydrate();
  });
  widget.addEventListener('focusin', hydrate);
  window.addEventListener('hashchange', () => {
    if (location.hash === '#ProductReviews') hydrate();
  });

  if (location.hash === '#ProductReviews' || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
    hydrate();
  } else {
    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) hydrate();
    }, { rootMargin: '800px 0px' });
    observer.observe(widget);
  }
})();
